import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ApiUrl from '../../utils/config';
import { useAuth } from './AuthContext';
import PasswordRequirements from './PasswordRequirements';
import { validatePassword } from '../../utils/passwordPolicy';

const ChangePassword: React.FC = () => {
  const { user, markPasswordChanged } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Пароль выдан системой (восстановление через почту) — показываем приглашение его заменить
  const forced = Boolean(user?.mustChangePassword) || Boolean((location.state as any)?.forced);

  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (newPassword !== confirmPassword) {
      setError('Новый пароль и подтверждение не совпадают.');
      return;
    }
    if (newPassword === currentPassword) {
      setError('Новый пароль должен отличаться от текущего.');
      return;
    }
    const policyError = validatePassword(newPassword);
    if (policyError) {
      setError(policyError);
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${ApiUrl}/api/Auth/change-password`, { currentPassword, newPassword });
      markPasswordChanged();
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setSuccess('Пароль успешно изменён.');
    } catch (err: unknown) {
      const msg = axios.isAxiosError(err) && err.response?.data?.message
        ? err.response.data.message
        : 'Не удалось изменить пароль. Попробуйте позже.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page auth-page">
      <h2>Смена пароля</h2>

      {forced && !success && (
        <div className="auth-page__notice">
          Вы вошли с временным паролем, который пришёл вам на почту. Рекомендуем сразу заменить его на свой.
          В поле «Текущий пароль» укажите пароль из письма.
        </div>
      )}
      {error && <div className="error-message auth-page__error">{error}</div>}
      {success && <div className="auth-page__success">{success}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Текущий пароль:</label>
          <input
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            autoComplete="current-password"
            required
            disabled={loading}
          />
        </div>

        <div className="form-group">
          <label>Новый пароль:</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoComplete="new-password"
            required
            disabled={loading}
          />
          <PasswordRequirements password={newPassword} />
        </div>

        <div className="form-group">
          <label>Подтвердите новый пароль:</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            autoComplete="new-password"
            required
            disabled={loading}
          />
        </div>

        <div className="form-actions">
          <button type="submit" className="btn" disabled={loading}>
            {loading ? 'Сохранение…' : 'Сменить пароль'}
          </button>
          {forced && !success ? (
            <button type="button" className="btn btn--back" onClick={() => navigate('/')}>
              Сменить позже
            </button>
          ) : (
            <Link to="/">
              <button type="button" className="btn btn--back">{success ? 'На главную' : 'Отмена'}</button>
            </Link>
          )}
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
